import React, { useEffect, useState } from "react";
import Select from "react-select";
import CreatableSelect from "react-select/creatable";
import { filterWondersoftDrugs, getDrugById } from "core/services/api";
import Toast from 'components/Toast';

const PreMedicationRow = ({ preMedicationInfo,
  provider, readOnly, appointmentDetails, order, i, j, setPreMedicationInfo, title, handleChange, handleBlur, selectedInputValues, newMedicine, setSelectedInputValues, handleInputChange, adjustTextareaHeight, handleChangeDuration, setInputValue, options1, allDrugs
}: any): JSX.Element => {

  const [medicineOptions, updateMedicineOptions] = useState([])

  const [drugDosage, setDrugdosage] = useState<any>()
  const [showdrugValidation, setShowdrugvalidation] = useState(false)
  const fetchDosage = (drugId: any) => {
    getDrugById(drugId).then((res) => {
      setDrugdosage(res)
    })
  }

  const drugDosageValidation = (value: any) => {
    if (Object.keys(drugDosage).length > 0) {
      const numericValueDosage = parseFloat(drugDosage?.upperLimit?.match(/\d+/)[0]);
      const numericValue = parseFloat(value?.match(/\d+/)[0]);
      if (drugDosage?.upperLimit !== null && drugDosage?.lowerLimit !== null) {
        if (
          (numericValue > numericValueDosage)
        ) {
          setShowdrugvalidation(true)
        }
      }
    }
  }

  function fetchMedicine() {
    const temp = allDrugs?.map((each: any) => ({
      label: each?.brandName,
      value: each?.id,
    }))
    const sortedTemp = temp?.sort((a: any, b: any) => {
      if (a?.label?.toLowerCase() < b?.label.toLowerCase()) {
        return -1
      }
      if (a?.label.toLowerCase() > b?.label.toLowerCase()) {
        return 1
      }
      return 0
    })

    updateMedicineOptions(sortedTemp)
  }

  useEffect(() => {
    fetchMedicine()
  }, [allDrugs])

  const filterDrugType = (drugType: any, searchText: any) => {
    let url = "";
    if (drugType) {
      url = `?drugType=${drugType}`;
    }
    if (searchText) {
      if (url === "") {
        url = `?searchText=${searchText}`;
      } else {
        url = url + `&searchText=${searchText}`;
      }
    }

    filterWondersoftDrugs(url)
      .then((res: any) => {
        const temp = res?.map((each: any) => ({
          label: each?.brandName,
          value: each?.id,
        }))
        const sortedTemp = temp?.sort((a: any, b: any) => {
          if (a?.label?.toLowerCase() < b?.label.toLowerCase()) {
            return -1
          }
          if (a?.label.toLowerCase() > b?.label.toLowerCase()) {
            return 1
          }
          return 0
        })
        updateMedicineOptions(sortedTemp)
      })
      .catch((err: any) => {
        console.log("filter drug type error", err)
      })

  }

  return (
    <>
      < div className="dynamic-parent-pre" key={j} ref={provider.innerRef} {...provider.draggableProps} >
        <div>
          <div
            {...provider.dragHandleProps}
            className={`dynamic-child ${readOnly ? "read-only" : ""} ${(
              preMedicationInfo[i]?.isCancelled ||
              readOnly ||
              appointmentDetails?.appointmentType === "OPD" ||
              (appointmentDetails?.appointmentType === "IPD" && !order?.isActive && !order?.isCompleted)
            ) ? "disabledDiv" : ""}`}
            style={{
              margin: "0px 0px 5px 0px",
              display: "flex",
              flexDirection: "row",
              alignItems: "center",
              justifyContent: "center"
            }}
          >
            <img src="../../../../assets/images/drag-drop-icon.svg" style={{ marginBottom: "3px", marginRight: "5px" }} />
            {j + 1}
          </div>
        </div>

        <div>
          <Select
            className={`dynamic-child ${readOnly ? "read-only" : ""} ${(
              preMedicationInfo[i]?.isCancelled ||
              readOnly ||
              appointmentDetails?.appointmentType === "OPD" ||
              (appointmentDetails?.appointmentType === "IPD" && !order?.isActive && !order?.isCompleted)
            ) ? "disabledDiv" : ""}`}
            defaultValue={{
              label: "",
              value: ""
            }}
            value={{
              label: preMedicationInfo[i].medicines[j].type,
              value: ""
            }}
            name="type"
            options={
              (preMedicationInfo[i].medicines[j].typeOptions && preMedicationInfo[i].medicines[j].typeOptions.length > 0)
                ? preMedicationInfo[i].medicines[j].typeOptions.map((options: any) => ({
                  label: options,
                  value: options
                }))
                : title
            }
            onChange={(e: any) => {
              const values = [...preMedicationInfo]
              values[i].medicines[j].type = e?.value
              setPreMedicationInfo([...values]);
              filterDrugType(e?.value, "");
            }}
            isDisabled={preMedicationInfo[i]?.isCancelled ? true : false || readOnly || appointmentDetails?.appointmentType === "OPD" || ((appointmentDetails?.appointmentType === "IPD") && (!order?.isActive && !order?.isCompleted))}
          />

        </div>
        <div title={
          preMedicationInfo[i].medicines[j]?.medicineName
        }>
          <CreatableSelect
            isClearable
            className={`dynamic-child med-name-style-chemo ${readOnly ? "read-only" : ""} ${(
              preMedicationInfo[i]?.isCancelled ||
              readOnly ||
              appointmentDetails?.appointmentType === "OPD" ||
              (appointmentDetails?.appointmentType === "IPD" && !order?.isActive && !order?.isCompleted)
            ) ? "disabledDiv" : ""}`}
            // styles={{
            //   control: (provided, state) => ({
            //     ...provided,
            //     width: "290px"
            //   })
            // }}
            value={
              preMedicationInfo[i].medicines[j]?.medicineName
                ? medicineOptions?.filter(
                  ({ label }) => label === preMedicationInfo[i].medicines[j]?.medicineName
                )?.length > 0 ? medicineOptions?.filter(
                  ({ label }) => label === preMedicationInfo[i].medicines[j]?.medicineName
                ) : { label: preMedicationInfo[i].medicines[j]?.medicineName, value: preMedicationInfo[i].medicines[j]?.medicineName }
                : newMedicine
            }
            onChange={(e: any) => {
              handleChange(e, i, j, "preMedication");
              fetchDosage(e?.value);
              handleBlur("preMedication", i, j);
            }}
            inputValue={selectedInputValues?.preMedication?.[i]?.medicines?.[j]}
            onInputChange={(newValue: string) => {
              if (newValue !== undefined) {
                const selected: any = { ...selectedInputValues };
                if (!selected["preMedication"][i]) {
                  selected["preMedication"][i] = { medicines: [] };
                }
                selected["preMedication"][i]["medicines"][j] = newValue;
                setSelectedInputValues(selected);
              } else {
                const selected: any = { ...selectedInputValues };
                selected["preMedication"][i]["medicines"][j] = "";
                setSelectedInputValues(selected);
              }
            }}
            onFocus={(e: any) => {
              handleInputChange("preMedication", i, j, preMedicationInfo[i].medicines[j]?.medicineName);
            }}
            options={medicineOptions}
            filterOption={(option: any, input: any) => option?.label?.toLowerCase()?.includes(input?.toLowerCase())}
            isDisabled={preMedicationInfo[i]?.isCancelled ? true : false || readOnly || appointmentDetails?.appointmentType === "OPD" || ((appointmentDetails?.appointmentType === "IPD") && (!order?.isActive && !order?.isCompleted))}

          />

        </div>

        <div>
          <input
            value={preMedicationInfo[i].medicines[j].dose}
            style={{ whiteSpace: 'pre-wrap', padding: '5px 8px' }}
            className={`dynamic-child ${readOnly ? "read-only" : ""}`}
            name="dose"
            type='text'
            onChange={(e: any) => {
              const values = [...preMedicationInfo]
              values[i].medicines[j].dose = e.target.value
              setPreMedicationInfo([...values]);

            }}
            onBlur={(e: any) => {
              const values = [...preMedicationInfo]
              values[i].medicines[j].dose = e.target.value
              setPreMedicationInfo([...values]);
              drugDosageValidation(e.target.value)
            }}
            disabled={preMedicationInfo[i]?.isCancelled ? true : false || readOnly || appointmentDetails?.appointmentType === "OPD" || ((appointmentDetails?.appointmentType === "IPD") && (!order?.isActive && !order?.isCompleted))}
          />

        </div>
        <div>
          <input
            value={preMedicationInfo[i].medicines[j].when}
            style={{ whiteSpace: 'pre-wrap', padding: '5px 8px' }}
            className={`dynamic-child ${readOnly ? "read-only" : ""}`}
            name="when"
            onChange={(e: any) => {
              const values = [...preMedicationInfo]
              values[i].medicines[j].when = e.target.value
              setPreMedicationInfo([...values]);
            }}
            disabled={preMedicationInfo[i]?.isCancelled ? true : false || readOnly || appointmentDetails?.appointmentType === "OPD" || ((appointmentDetails?.appointmentType === "IPD") && (!order?.isActive && !order?.isCompleted))}
          />

        </div>
        <div>
          <input
            value={preMedicationInfo[i].medicines[j].route}
            style={{ whiteSpace: 'pre-wrap', padding: '5px 8px' }}
            className={`dynamic-child ${readOnly ? "read-only" : ""}`}
            name="route"
            onChange={(e: any) => {
              const values = [...preMedicationInfo]
              values[i].medicines[j].route = e.target.value
              setPreMedicationInfo([...values]);
            }}
            disabled={preMedicationInfo[i]?.isCancelled ? true : false || readOnly || appointmentDetails?.appointmentType === "OPD" || ((appointmentDetails?.appointmentType === "IPD") && (!order?.isActive && !order?.isCompleted))}
          />
        </div>
        <div style={{ height: "auto" }}>
          <textarea
            value={preMedicationInfo[i].medicines[j].instructions}
            style={{
              minHeight: "100%",
              whiteSpace: 'pre-wrap',
              padding: '5px 8px',
              display: "flex",
              alignItems: "center",
              overflow: "hidden",
              resize: "none"
            }}
            className={`autoHeightTextarea dynamic-child ${readOnly ? "read-only" : ""}`}
            name="instructions"
            rows={1}
            onChange={(e: React.ChangeEvent<HTMLTextAreaElement>) => {
              const values = [...preMedicationInfo];
              values[i].medicines[j].instructions = e.target.value;
              setPreMedicationInfo([...values]);
              adjustTextareaHeight();
            }}
            disabled={preMedicationInfo[i]?.isCancelled ? true : false || readOnly || appointmentDetails?.appointmentType === "OPD" || ((appointmentDetails?.appointmentType === "IPD") && (!order?.isActive && !order?.isCompleted))}
          />
        </div>

        <div>
          <Select
            id="pre-notes"
            value={{
              label: preMedicationInfo[i].medicines[j].duration,
              value: preMedicationInfo[i].medicines[j].duration
            }}
            className={`dynamic-child ${readOnly ? "read-only" : ""} ${(
              preMedicationInfo[i]?.isCancelled ||
              readOnly ||
              appointmentDetails?.appointmentType === "OPD" ||
              (appointmentDetails?.appointmentType === "IPD" && !order?.isActive && !order?.isCompleted)
            ) ? "disabledDiv" : ""}`}
            name="duration"
            onChange={(e: any) => {
              const values = [...preMedicationInfo]
              values[i].medicines[j].duration = e.value
              setPreMedicationInfo([...values]);
              setInputValue(e ? e.value : '');
            }}
            onInputChange={(inputValue) => handleChangeDuration({ value: inputValue, label: inputValue })}
            options={options1}
            isDisabled={preMedicationInfo[i]?.isCancelled ? true : false || readOnly || appointmentDetails?.appointmentType === "OPD" || ((appointmentDetails?.appointmentType === "IPD") && (!order?.isActive && !order?.isCompleted))}
          />
        </div>


        <div style={{ display: "flex", alignItems: "center", justifyContent: "center" }}>
          <input
            type="checkbox"
            checked={
              preMedicationInfo[i]?.medicines[j]?.sideEffectCheck
            }

            name="route"
            onChange={(e: any) => {
              const values = [...preMedicationInfo]
              values[i].medicines[j].sideEffectCheck = e.target.checked
              setPreMedicationInfo([...values]);
            }}
            disabled={preMedicationInfo[i]?.isCancelled ? true : false || readOnly || appointmentDetails?.appointmentType === "OPD" || ((appointmentDetails?.appointmentType === "IPD") && (!order?.isActive && !order?.isCompleted))}
          />
        </div>
        {
          preMedicationInfo[i].medicines.length > 1 ?
            (!readOnly && (
              <button
                className="delete-icon"
                onClick={() => {
                  const values = [...preMedicationInfo]
                  if (values[i].medicines.length > 1) {
                    values[i].medicines.splice(j, 1)
                    setPreMedicationInfo(values)

                    const selected: any = { ...selectedInputValues }
                    selected["preMedication"][i]["medicines"].splice(j, 1)
                    setSelectedInputValues(selected)
                  }

                }}
                disabled={preMedicationInfo[i]?.isCancelled ? true : false || readOnly || appointmentDetails?.appointmentType === "OPD" || ((appointmentDetails?.appointmentType === "IPD") && (!order?.isActive && !order?.isCompleted))}
              >
                <img
                  src="../../../../assets/images/delete-icon.svg"
                  alt=""
                />
              </button>
            )) : (
              !readOnly && (
                <button
                  className="delete-icon"
                  style={{ cursor: "not-allowed" }}
                >
                  <img
                    src="../../../../assets/images/delete-icon.svg"
                    alt=""
                  />
                </button>
              ))
        }
      </div>

      {showdrugValidation && (
        <Toast
          textMessage={`Check the UpperLimit ${drugDosage?.upperLimit === null ? "" : drugDosage?.upperLimit} `}
          onCloseText={"Close"}
          type={"error"}
          onClose={() => setShowdrugvalidation(false)}
        ></Toast>
      )}
    </>
  )

}

export default PreMedicationRow